import * as actionType from "./actionTypes";
import axios from "../../shared/axios";
import { getFormatedArray } from "../../shared/firebaseHelper";

const fetchCurriculumStart = () => ({
  type: actionType.FETCH_CURRICULUM_START,
});

const fetchCurriculumSuccess = (curriculum) => ({
  type: actionType.FETCH_CURRICULUM_SUCCESS,
  curriculum,
});

const fetchCurriculumFail = (error) => ({
  type: actionType.FETCH_CURRICULUM_FAIL,
  error,
});

export const fetchCurriculum = () => async (dispatch) => {
  dispatch(fetchCurriculumStart());

  try {
    const res = await axios.get("curriculum.json");
    const fetchedCurriculumns = getFormatedArray(res.data);

    fetchedCurriculumns.sort((a, b) => (a.order > b.order ? 1 : -1));

    fetchedCurriculumns.forEach((cvEntry) => {
      cvEntry.companyLogo = require(`../../assets/images/${cvEntry.companyLogo}`).default;
    });
    dispatch(fetchCurriculumSuccess(fetchedCurriculumns));
  } catch (error) {
    dispatch(fetchCurriculumFail(error.message));
  }
};
